// Author NYA
// Date 2020-11-10 11:33:21

class SithMesPrdEhs {
constructor({
        id = null,
        ehsStartDate = '',
        mstLocationId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.ehsStartDate = ehsStartDate;
    this.mstLocationId = mstLocationId;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdEhs();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'ehsStartDate',
        label: 'label.sith.prd.sithMesPrdEhs.grid.ehsStartDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationId',
        label: 'label.sith.prd.sithMesPrdEhs.grid.mstLocationId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdEhs.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    ehsStartDateRteFilter : "",
    ehsStartDateLteFilter : "",
    mstLocationIdFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'ehsStartDateRteFilter',
        label: 'label.sith.prd.sithMesPrdEhs.filter.ehsStartDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'ehsStartDateLteFilter',
        label: 'label.sith.prd.sithMesPrdEhs.filter.ehsStartDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'mstLocationIdFilter',
        label: 'label.sith.prd.sithMesPrdEhs.filter.mstLocationId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'ehsStartDate',
        label: 'label.sith.prd.sithMesPrdEhs.entity.ehsStartDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'mstLocationId',
        label: 'label.sith.prd.sithMesPrdEhs.entity.mstLocationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdEhs.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdEhs, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
